import React from 'react';
import { Segment, Button, Header, Image } from 'semantic-ui-react';

const NotAuthorized = () => {
    return (
        <Segment placeholder>
            <Image src={"https://media1.tenor.com/images/a64d9aa44d276f7d552e78c02cc4fae5/tenor.gif?itemid=13001229"} size='massive' />

            <Header icon>
                Oops - You aren't authorized to view this page.
            </Header>
            <Segment.Inline>
                <Button primary>
                    This is an Unused button
                </Button>
            </Segment.Inline>
        </Segment>
    );
};

export default NotAuthorized;